import { render, staticRenderFns } from "./DisplayProtocolClient.vue?vue&type=template&id=150ed143&scoped=true&"
import script from "./DisplayProtocolClient.vue?vue&type=script&lang=js&"
export * from "./DisplayProtocolClient.vue?vue&type=script&lang=js&"
import style0 from "./DisplayProtocolClient.vue?vue&type=style&index=0&id=150ed143&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150ed143",
  null
  
)

export default component.exports